import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import { createUserActions } from './actions';
import { UserActions, UserState } from './types';

export const useUserStore = create<UserState & UserActions>()(
    immer((set, get, store) => ({
        selectedUser: null,
        sessionMetadata: {},
        session: {},
        loadingUser: false,
        error: undefined,
        ...createUserActions(set, get, store),
    })),
);
